import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const remove = async (data: { _id: string }) => {
  const response: TServerResponse = await request({
    url: apiUrls.homeBanner.DELETE_BANNER,
    method: "POST",
    data,
  });
  return response;
};

export const useRemoveBannerMutation = () => {
  return useMutation({ mutationFn: remove });
};
